const { tokenizeCard } = require('components/adyen_tokenization');
const { validateRequiredFields, displayValidationErrors } = require('components/forms.js');
const { forEach } = require('lodash');
const creditCardType = require('credit-card-type');
const elog = require('@reverbdotcom/elog').default;

const adyenFormSelector = '[data-adyen-form]';
const adyenInputDataAttribute = 'data-adyen-name';
const adyenInputSelector = `[${adyenInputDataAttribute}]:enabled`;

const adyenTokenizationParams = ($form) => {
  const adyenParams = {};

  $form.find(adyenInputSelector).each((_index, el) => {
    const value = $(el).val();
    const name = $(el).attr(adyenInputDataAttribute);
    adyenParams[name] = value;
  });

  return adyenParams;
};

const appendHiddenInput = ($form, name, value) => {
  const hiddenField = $('<input>').attr({
    type: 'hidden',
    name,
    value,
  });

  $form.append(hiddenField);
};

const shouldTokenize = ($form) => {
  const newCardFieldsContainer = $form.find('[data-new-credit-card-fields]');
  const isCreatingCard = newCardFieldsContainer.is(':visible');
  const isUpdatingCard = newCardFieldsContainer.length === 0;

  return isCreatingCard || isUpdatingCard;
};

const disableNewCardInputs = $form =>
  forEach($form.find(adyenInputSelector), el => el.setAttribute('disabled', true));

const enableNewCardInputs = $form =>
  forEach($form.find(adyenInputSelector), el => el.removeAttribute('disabled'));

const appendAdyenToken = $form =>
  appendHiddenInput($form, 'adyen_token', tokenizeCard(adyenTokenizationParams($form)));

const removeWhitespace = string => (string || '').replace(/\s/g, '');

const detectCardType = ($form) => {
  const { number } = adyenTokenizationParams($form);
  const formattedCardNumber = removeWhitespace(number);
  const cardTypeInfo = creditCardType(formattedCardNumber)[0] || {};
  return cardTypeInfo.niceType;
};

const lastFourCardNumberDigits = ($form) => {
  const { number } = adyenTokenizationParams($form);
  const formattedCardNumber = removeWhitespace(number);
  return formattedCardNumber.slice(-4);
};

const appendCardType = $form =>
  appendHiddenInput($form, 'credit_card[type]', detectCardType($form));

const appendCardLastFour = $form =>
  appendHiddenInput($form, 'credit_card[last_4]', lastFourCardNumberDigits($form));

const tokenizeAndSubmitForm = (event) => {
  try {
    event.preventDefault();

    const $form = $(event.target).closest(adyenFormSelector);

    // Adyen tokenized inputs have "data-adyen-name" and
    // "data-force-validation" instead of "name" and "required".
    // If choosing an existing card, there is no need for tokenization,
    // so these inputs are marked as disabled before validating the form.
    if (!shouldTokenize($form)) {
      disableNewCardInputs($form);
    }

    if (!validateRequiredFields($form)) {
      displayValidationErrors($form);
      enableNewCardInputs($form);
      return;
    }

    if (shouldTokenize($form)) {
      appendAdyenToken($form);
      appendCardType($form);
      appendCardLastFour($form);
    }

    $form[0].submit();
  } catch (errorMessage) {
    elog.error('adyen.form_submit.error', errorMessage);
  }
};

const init = () => {
  $(document).on('submit', adyenFormSelector, tokenizeAndSubmitForm);
};

$(init);

module.exports = {
  init,
  adyenTokenizationParams,
};



// WEBPACK FOOTER //
// ./javascripts/components/adyen_ujs.js